<script setup>
import {computed, inject} from "vue";
import {Link, usePage} from "@inertiajs/vue3";
import axios from "axios";

const props = defineProps({
    relate_news: Array,
});
async function onShowDialog(id) {
    await axios.get(route('update.count'),{
        params: {
            id: id,
        },
    });
}

const setAudioSource = inject('setAudioSource');

function playAudio(id, title, image, link_url) {
    setAudioSource(id, title, image, link_url);
    onShowDialog(id);
}

</script>

<template>

    <div class="container pa-0 mt-5" v-if="relate_news.length > 0">
        <h4 class="mt-3" style="font-size: 20px">{{ $t('share.popular') }}</h4>
        <div :key="index" v-for="(post,index) in relate_news">
            <v-divider class="ma-0" v-if="index > 0"></v-divider>
            <div class="py-2 d-flex align-items-center justify-content-start" v-if="post.format==='audios'" @click="playAudio(post.id, post.title, post.image, post.link_url)">
                        <v-card flat width="70" height="70" class="position-relative small-image mr-2">
                            <img @click="onShowDialog(post.id)" :src="post.image ? getImage(post.image) : '/assets/img/sub-article.png'" alt="Buddha Image" class="media-img w-100 h-100 object-fit-cover">
                            <div class="play-button">
                                <img src="/assets/img/logo-youtube.png" alt="Buddha Image" style="width: 30px; height: 30px; object-fit: cover;">
                            </div>
                        </v-card>
                        <div class="pl-1 w-66">
                            <h6 @click="onShowDialog(post.id)" class=" title-text text-black mb-2">{{ getTitle(post.title, 50) }}</h6>
<!--                            <div class="subtitle-text one-line-text">{{ post.format }} - {{ post.first_name }}</div>-->
<!--                            <div class="small-text one-line-text">{{ humanDate(post.updated_at) }}</div>-->
                            <Link :key="category.id" v-for="category in post.categories" :href="route('category', category.slug)"><span> {{ category.name }}</span></Link>

                        </div>
                    </div>

            <v-divider class="ma-0" v-if="index > 0"></v-divider>
          
            <v-dialog max-width="800" hight="100%" class="flex items-stretch" v-if="post.format==='videos'"
                   >
                <template v-slot:activator="{ props: activatorProps }">
                    <div class="py-2 d-flex align-items-center justify-content-start" v-bind="activatorProps">
                        <v-card flat width="70" height="70" class="position-relative small-image mr-2">
                            <img  @click="onShowDialog(post.id)" :src="post.image ? getImage(post.image) : '/assets/img/sub-article.png'" alt="Buddha Image" class="media-img w-100 h-100 object-fit-cover">
                            <div class="play-button">
                                <img src="/assets/img/logo-youtube.png" alt="Buddha Image" style="width: 30px; height: 30px; object-fit: cover;">
                            </div>
                        </v-card>
                        <div class="pl-1 w-66">
                            <h6  @click="onShowDialog(post.id)" class="title-text text-black mb-2">{{ getTitle(post.title, 50) }}</h6>
                            <Link :key="category.id" v-for="category in post.categories" :href="route('category', category.slug)"><span> {{ category.name }}</span></Link>

                            <!--                            <div class="subtitle-text one-line-text">{{ post.format }} - {{ post.first_name }}</div>-->
<!--                            <div class="small-text one-line-text">{{ humanDate(post.updated_at) }}</div>-->
                        </div>
                    </div>

                </template>

                <template v-slot:default="{ isActive }">
                    <v-card>
                        <iframe width="100%" height="500" :src="'https://www.youtube.com/embed/'+ post.link_url +'?si=beajwk0lgRip4bOO'"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

                    </v-card>
                </template>

            </v-dialog>

            <Link v-if="post.format==='others' || post.format==='news' || post.format==='books'" :href="route('detail', post.id)">
                <div class="py-2 d-flex align-items-center justify-content-start" >
                    <v-card flat width="70" height="70" class="mr-2">
                        <img :src="post.image ? getImage(post.image) : '/assets/img/sub-article.png'" alt="Buddha Image" class="media-img w-100 h-100 object-fit-cover">
                    </v-card>
                    <div class="pl-1 w-66">
                        <h6 class="title-text text-black mb-2">{{ getTitle(post.title, 60) }}</h6>
                        <Link :key="category.id" v-for="category in post.categories" :href="route('category', category.slug)"><span> {{ category.name }}</span></Link>

                        <!--                        <div class="subtitle-text one-line-text">{{ post.format }} - {{ post.first_name }}</div>-->
<!--                        <div class="small-text one-line-text">{{ humanDate(post.updated_at) }}</div>-->
                    </div>
                </div>
            </Link>
        </div>
    </div>
</template>

<style scoped>

.media-img {
    width: 40px;
    height: 40px;
    /* object-fit: cover; */
    border-radius: 10px;
    margin-right: 15px;
}

.subtitle-text {
    color: #6c757d; /* Muted gray */
    font-size: 14px;
}

.small-text {
    font-size: 12px;
    color: #6c757d;
}
</style>
